<div ngbDropdown class="h-100 w-100" placement="bottom-end">
  <button type="button" class="btn btn-{{theme}} h-100" id="language" ngbDropdownToggle>
    Español
  </button>
  <div ngbDropdownMenu aria-labelledby="language">
    <button ngbDropdownItem>Español</button>
    <button ngbDropdownItem [disabled]="true">English</button>
  </div>
</div>